import { gql } from '@apollo/client';
import INSTANT_REPORT_FRAGMENT from '../fragments/instantReportFragment';

const GET_UNREVIEWED_REPORT_BY_ID = gql`
  query getUnreviewedReportById($input: getUnreviewedReportByIdInput) {
    getUnreviewedReportById(input: $input) {
      isSuccess
      message
      report {
        ...InstantReportFragment
      }
    }
  }

  ${INSTANT_REPORT_FRAGMENT}
`;

export default GET_UNREVIEWED_REPORT_BY_ID;
